import { SET_RECETAS_PAGINADAS } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case SET_RECETAS_PAGINADAS:
      return {
        ...state,
        recetas: action.payload,
      };
    default:
      return state;
  }
};
